import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SyncSharpIcon from '@mui/icons-material/SyncSharp';
import { FormattedMessage } from 'react-intl';
import { CopyrightFooter } from 'modules/common/components/CopyrightFooter';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100vh',
    background: theme.palette.information.pageBackground,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(15),
    justifyContent: 'space-between'
  },
  wrapper: {
    height: '65vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: theme.palette.information.pageBackground
  },
  box: {
    display: 'flex',
    justifyContent: 'center'
  },
  icon: {
    color: theme.palette.info.main,
    fontSize: theme.spacing(22),
    opacity: '56%'
  },
  title: {
    margin: theme.spacing(5, 0, 0, 0),
    fontWeight: theme.typography.h3.fontWeight,
    color: theme.palette.text.primary
  },
  subtitle: {
    color: theme.palette.text.secondary
  }
}));

export const InstalledCollectorsEmptyPage: React.FC = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <div
        className={classes.wrapper}
        data-testid="installed-collectors-empty-page"
      >
        <Box className={classes.box}>
          <SyncSharpIcon className={classes.icon} />
        </Box>
        <Box className={classes.box}>
          <Typography variant="h3" className={classes.title}>
            <FormattedMessage id="installedCollectors.empty.title" />
          </Typography>
        </Box>
        <Box className={classes.box}>
          <Typography variant="h6" className={classes.subtitle}>
            <FormattedMessage id="installedCollectors.empty.subtitle" />
          </Typography>
        </Box>
      </div>
      <CopyrightFooter />
    </Container>
  );
};
